import { Game } from '../models/Game';

export enum MarkersKeys {
    EndOfPreroll = 'EndOfPreroll',
    GameStart = 'GameStart',
    PlayGameClick = 'PlayGameClick',
    PlayAgainClick = 'PlayAgainClick',
    AdStart = 'AdStart',
    DefaultNavigationStart = 'navigationStart'
}

export class  MeasureService {

    public static measure(game: Game, marker1: MarkersKeys, marker2: MarkersKeys ): PerformanceEntry {
        const m1 = performance.getEntriesByName(marker1, 'mark');
        if (marker1 !== MarkersKeys.PlayAgainClick && !m1.length) {
            return null;
        }

        const m2 = performance.getEntriesByName(marker2, 'mark');
        if (!m2.length) {
            return null;
        }

        const name = `ark_${game.slug}_${marker1}_${marker2}`;
        marker1 = (marker1 === MarkersKeys.PlayAgainClick) ? MarkersKeys.DefaultNavigationStart : marker1;

        performance.measure(name, marker1, marker2);
        return performance.getEntriesByName(name, 'measure')[0];
    }

    public static clearMarks() {
        for (const element in MarkersKeys) {
            if (MarkersKeys.hasOwnProperty(element)) {
                performance.clearMarks(element);
            }
        }
    }

    public static clearMeasures(pe: PerformanceEntry) {
        performance.clearMeasures(pe.name);
    }
}
